import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Dealer, DealerUpdate } from '../../../shared/interfaces/dealer.interfaces';

const basePath = '/dealer';

@Injectable({
  providedIn: 'root'
})

export class DealerService {
  constructor(private http: HttpClient) { }

  // Gets details of the current dealer
  getDealer(): Observable<Dealer> {
    return this.http.get<Dealer>(`${basePath}`);
  }

  // Updates details of the current dealer
  updateDealer(payload: DealerUpdate): Observable<Dealer> {
    const body = payload
    return this.http.put<Dealer>(`${basePath}`, body);
  }

}
